const SITE_NAME = "Entorno Biai";
const BASE_URL = "https://www.entornobiai.com";
const DEFAULT_DESCRIPTION =
  "Reparación profesional de celulares y computadores en Yarumal. Cámaras de seguridad, apoyo educativo y accesorios tecnológicos en Antioquia. Entorno Biai.";

export interface SeoMeta {
  title: string;
  description: string;
  canonical: string;
}

export const SEO_DEFAULTS = {
  siteName: SITE_NAME,
  baseUrl: BASE_URL,
  defaultDescription: DEFAULT_DESCRIPTION,
  ogImage: `${BASE_URL}/favicon/android-chrome-512x512.png`,
} as const;

export const PAGE_SEO: Record<string, SeoMeta> = {
  "/": {
    title: `${SITE_NAME} | Reparación de Celulares, Tecnología y Educación`,
    description: DEFAULT_DESCRIPTION,
    canonical: `${BASE_URL}/`,
  },
  "/ubicacion": {
    title: `Ubicación | ${SITE_NAME}`,
    description:
      "Encuentra la ubicación de Entorno Biai en Yarumal, Antioquia. Calle 18 #20-71, horario de lunes a sábado de 9 a 7 pm.",
    canonical: `${BASE_URL}/ubicacion`,
  },
  "/reparacion-de-celulares": {
    title: `Reparación de Celulares | ${SITE_NAME}`,
    description:
      "Servicio profesional de reparación de celulares en Yarumal. Diagnóstico, cambio de pantalla, batería y más. Entorno Biai.",
    canonical: `${BASE_URL}/reparacion-de-celulares`,
  },
  "/reparacion-de-computadores": {
    title: `Reparación de Computadores | ${SITE_NAME}`,
    description:
      "Servicio de reparación de computadores en Yarumal. Mantenimiento preventivo y correctivo, formateo, y más. Entorno Biai.",
    canonical: `${BASE_URL}/reparacion-de-computadores`,
  },
  "/instalacion-de-camaras-de-seguridad": {
    title: `Instalación de Cámaras de Seguridad | ${SITE_NAME}`,
    description:
      "Instalación profesional de cámaras de seguridad en Yarumal y Norte de Antioquia. Cotización sin compromiso. Entorno Biai.",
    canonical: `${BASE_URL}/instalacion-de-camaras-de-seguridad`,
  },
  "/educacion": {
    title: `Educación y Formación Tecnológica | ${SITE_NAME}`,
    description:
      "Apoyo educativo para pregrado y maestría. Cursos y programas de formación en tecnología con acompañamiento profesional. Entorno Biai.",
    canonical: `${BASE_URL}/educacion`,
  },
  "/politica-de-privacidad": {
    title: `Política de Privacidad | ${SITE_NAME}`,
    description:
      "Consulta la política de privacidad de Entorno Biai. Conoce cómo recopilamos, usamos y protegemos tu información.",
    canonical: `${BASE_URL}/politica-de-privacidad`,
  },
  "/condiciones-del-servicio": {
    title: `Condiciones del Servicio | ${SITE_NAME}`,
    description:
      "Condiciones de uso del servicio de Entorno Biai. Compras, agendamiento de servicios y más.",
    canonical: `${BASE_URL}/condiciones-del-servicio`,
  },
};
